import LetterBoxContainer from "../../components/applications/letterBox";

const LetterBox = () => {
  return <LetterBoxContainer />;
};

export default LetterBox;
